module.exports = __webpack_public_path__ + "img/cover.33f9ddd0.jpg";